export var CameraTypes;
(function (CameraTypes) {
    CameraTypes["main"] = "main";
    CameraTypes["debug"] = "debug";
})(CameraTypes || (CameraTypes = {}));
export var CameraStates;
(function (CameraStates) {
    CameraStates["intro"] = "intro";
    CameraStates["intro2"] = "intro2";
    CameraStates["table"] = "table";
    CameraStates["disciplineIntro"] = "disciplineIntro";
    CameraStates["disciplineIntroSecond"] = "disciplineIntroSecond";
    CameraStates["discipline"] = "discipline";
    CameraStates["disciplineOutro"] = "disciplineOutro";
    CameraStates["static"] = "static";
})(CameraStates || (CameraStates = {}));
//# sourceMappingURL=index.js.map